import { render, staticRenderFns } from "./request-summary.vue?vue&type=template&id=1b6ee685&scoped=true&"
import script from "./request-summary.vue?vue&type=script&lang=js&"
export * from "./request-summary.vue?vue&type=script&lang=js&"
import style0 from "./request-summary.vue?vue&type=style&index=0&id=1b6ee685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ee685",
  null
  
)

export default component.exports